// @givmo/app-charity — the charity-admin role wire constants + the Owner gate (CPA-WEB2).
//
// The canonical charity-portal role enum is `CharityAdminMembershipType = 'Owner' | 'Member'` (the
// wire strings `CharityAdminOut.role`, `CharityMembershipOut.role` and the invite `role` carry).
// `isOwnerRole` is the class pages' Owner gate (payment, profile, settings, terms, p2p, enrollment,
// the CRM mount, the consenting-donors panel). The org-level tier is DISPLAYED through the org-console
// package's labeller ("Global Admin"), never through these strings: the one `Owner` literal here is
// the wire constant the package's copy rail enumerates (`packages/org-console/src/copy-law.test.ts`).

import type { CharityAdminMembershipType } from '@givmo/api-client';

export const ROLE_OWNER: CharityAdminMembershipType = 'Owner';
export const ROLE_MEMBER: CharityAdminMembershipType = 'Member';

/** Whether a role string is the Owner role. */
export function isOwnerRole(role: string | null | undefined): boolean {
  return role === ROLE_OWNER;
}
